module.exports = __webpack_public_path__ + "media/proximanova-regular.0b0a245f.woff";


//////////////////
// WEBPACK FOOTER
// ./fonts/proximanova-regular.woff
// module id = 105
// module chunks = 9